import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { ApiConnectionCard } from './ApiConnectionCard';
import { ConnectApiModal } from './ConnectApiModal';
const apiConnections = [{
  id: '1',
  name: 'Research Database',
  description: 'Primary research database integration for ADHD studies',
  status: 'connected',
  lastSync: '2025-04-28T10:30:00Z',
  type: 'document',
  documentsCount: 1250
}, {
  id: '2',
  name: 'Patient Portal',
  description: 'Patient data and assessment records',
  status: 'connected',
  lastSync: '2025-04-28T09:45:00Z',
  type: 'crm',
  documentsCount: 3420
}, {
  id: '3',
  name: 'Research Wiki',
  description: 'Internal research documentation and protocols',
  status: 'disconnected',
  lastSync: '2025-04-28T08:20:00Z',
  type: 'wiki',
  documentsCount: 892
}, {
  id: '4',
  name: 'Assessment Platform',
  description: 'AuDHD assessment and screening platform',
  status: 'connected',
  lastSync: '2025-04-28T07:15:00Z',
  type: 'helpdesk',
  documentsCount: 2150
}];
export const ExternalApisTab = () => {
  const [showConnectModal, setShowConnectModal] = useState(false);
  const handleConnect = (data: any) => {
    console.log('Connecting new API:', data);
    // Here you would typically make an API call to save the connection
    setShowConnectModal(false);
  };
  return <div className="space-y-8" data-id="element-693">
      <div className="flex items-start justify-between" data-id="element-694">
        <div data-id="element-695">
          <h2 className="text-xl font-medium text-white font-mono" data-id="element-696">
            External API Connections
          </h2>
          <p className="text-sm text-gray-400 mt-1" data-id="element-697">
            Manage your external data source connections
          </p>
        </div>
        <button onClick={() => setShowConnectModal(true)} className="flex items-center gap-2 px-4 py-2 bg-accent hover:bg-accent-light text-white 
                   rounded-none transition-colors font-mono text-sm uppercase tracking-wide" data-id="element-698">
          <PlusIcon size={16} data-id="element-699" />
          <span data-id="element-700">Connect New API</span>
        </button>
      </div>
      <div className="grid grid-cols-1 gap-6" data-id="element-701">
        {apiConnections.map(connection => <ApiConnectionCard key={connection.id} connection={connection} data-id="element-702" />)}
      </div>
      <ConnectApiModal isOpen={showConnectModal} onClose={() => setShowConnectModal(false)} onConnect={handleConnect} data-id="element-703" />
    </div>;
};